export { ReactComponent as QuestionsDropdown } from './svgs/questions-dropdown.svg';
